import React from 'react';

const SuccessIcon = ({ width = 20, height = 20, style = {} }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0, ...style }}
  >
    <circle cx="10" cy="10" r="10" fill="#32E5C5" />
    <path d="M6 10.5L8.5 13L14 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SuccessIcon;
